import React from 'react'
import Home from './Home'

const HomeContainer: React.FC = () => {
  return <Home />
}

export default HomeContainer
